import { UUID } from 'symbols';
import { DocStatusDetails } from '../../../apps/frontend/src/app/status-selector/symbols';
import { ClientModel } from '../clients/symbols';
import { DebtModel } from '../debts/symbols';
import { EquipmentModel } from '../equipments/symbols';
import { MasterModel } from '../masters/states/masters/masters.model';
import { UserModel } from '../profile/symbols';
import { ReceiptModel } from '../receipts/symbols';
import { AddressModel, BasicModel, TYPE_SEARCH } from '../symbols';
import { TalonModel } from '../talons/symbols';


export interface OrderModelExpectBackend extends BasicModel {
  id: string;
  street: string;
  country: string;
  city: string;
  lat: number;
  lng: number;
  masterId?: UUID;
  master?: UserModel;
  issuedAt: string;
  doneAt: string;
  docNumber: number;
  reason: string;
  comment: string;
  talons?: TalonModel[],
  status: {
    id?: UUID;
    status: OrderStatus
  };
  isHighPriority?: boolean;
  isDebt?: boolean;
  client?: ClientModel;
  clientId?: UUID;
  equipment?: Partial<EquipmentModel>;
  receipts?: ReceiptModel[];
  typeServiceId: UUID;
  isChanged?: boolean;
}


export interface OrderModel extends BasicModel {
  street: AddressModel['street'];
  country?: AddressModel['country'];
  city?: AddressModel['city'];
  lat?: AddressModel['location']['lat'];
  lng?: AddressModel['location']['lng'];
  masterId?: UUID;
  master?: MasterModel;
  issuedAt: string;
  doneAt: string;
  docNumber: number;
  reason: string;
  comment: string;
  status: {
    id?: UUID;
    status: OrderStatus
  };
  statusId: UUID;
  isHighPriority?: boolean;
  debtId?: UUID;
  debt: DebtModel;
  client?: ClientModel;
  clientId?: UUID;
  equipment?: Partial<EquipmentModel>;
  receipts?: ReceiptModel[];
  receiptsIds?: string[];
  typeServiceId: UUID;
  isChanged?: boolean;
  updater?: UserModel;
}

export enum OrderStatus {
  ACCEPTED = 'ACCEPTED',
  ISSUED = 'ISSUED',
  ISSUED_SELF = 'ISSUED_SELF',
  CANCELLED = 'CANCELLED',
  DONE = 'DONE',
  NOT_CONFIRMED = 'NOT_CONFIRMED',
}

export interface OrderStatusExpectBackend {
  id: UUID;
  status: OrderStatus;
}


export const ORDER_STATUSES_RELATED_NAMES = {
  ['null']: 'Не обрано',
  [OrderStatus.ACCEPTED]: 'Прийнята',
  [OrderStatus.ISSUED]: 'Видана',
  [OrderStatus.ISSUED_SELF]: 'Видана (WEB)',
  [OrderStatus.CANCELLED]: 'Відмінена',
  [OrderStatus.DONE]: 'Виконана',
  [OrderStatus.NOT_CONFIRMED]: 'Очікує підтвердження'
};

export const ORDER_STATUSES_CONFIG: { [status: string]: DocStatusDetails } = {
  null: {
    id: null,
    background: 'none',
    availableAsOption: true,
    name: 'Не обрано',
    color: 'var(--primary-text)',
    additionalConfirmation: false,
    confirmationText: '',
    detailsText: '',
    hint: 'Якщо статус не обрано, то замовлення не буде відображатись в списку замовлень.'
  },
  [OrderStatus.ACCEPTED]: {
    id: OrderStatus.ACCEPTED,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.ACCEPTED],
    color: 'var(--primary-text)',
    background: 'var(--accepted)',
    hint: 'Замовлення було прийняте, але ще не видане майстру.',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [OrderStatus.ISSUED]: {
    id: OrderStatus.ISSUED,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.ISSUED],
    color: 'var(--primary-text)',
    background: 'var(--issued)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: true,
    detailsText: 'При зміні на цей статус, буде оновлено дату видачі замовлення.',
    confirmationText: 'Хочете продовжити?'
  },
  [OrderStatus.ISSUED_SELF]: {
    id: OrderStatus.ISSUED_SELF,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.ISSUED_SELF],
    color: 'var(--primary-text)',
    background: 'var(--issued-self)',
    hint: 'Це замовлення було прийняте в роботу майстором самостійно через веб-додаток.',
    availableAsOption: false,
    additionalConfirmation: false
  },
  [OrderStatus.CANCELLED]: {
    id: OrderStatus.CANCELLED,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.CANCELLED],
    color: 'var(--primary-text)',
    background: 'var(--cancelled)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [OrderStatus.DONE]: {
    id: OrderStatus.DONE,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.DONE],
    color: 'var(--primary-text)',
    background: 'var(--text-primary-light)',
    hint: '',
    availableAsOption: true,
    additionalConfirmation: false
  },
  [OrderStatus.NOT_CONFIRMED]: {
    id: OrderStatus.NOT_CONFIRMED,
    name: ORDER_STATUSES_RELATED_NAMES[OrderStatus.NOT_CONFIRMED],
    color: 'var(--primary-text)',
    background: 'var(--not-confirmed)',
    hint: 'Замовлення уже виконано, але акти виконання ще не проведені.',

    availableAsOption: false,
    additionalConfirmation: false
  }
};

export interface OrderFilterModel {
  isHighPriority?: boolean;
  isDebt?: boolean;
  isToxic?: boolean;
  masterId?: UUID;
  statusIds?: string[];
  searchText?: string;
  typeSearch?: TYPE_SEARCH;
  startDate?: string;
  isNewEquipment?: boolean;
  isUsedEquipment?: boolean;
}


export interface OrdersCountModel {
  acceptedCount: number;
  issuedCount: number;
  notConfirmedCount: number;
}


export const ORDER_LOCAL_STORAGE_KEY = 'orders_data';

export interface NearbyOrderModel {
  id: string;
  docNumber: number;
  street: string;
  city?: string;
  country?: string;
  status: string;
  reason?: string;
  equipmentName?: string;
  distanceKm: number;
}
